// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2G7LH","inner":"Footer_inner__3F5_q","nextIcon":"Footer_nextIcon__x0Kut","innerLeft":"Footer_innerLeft__Uu4rf"};